import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { LANGUAGE_EN } from '@home/_config/config';
import { useIntl } from 'umi';
import { getName } from '@home/utils/common';

const BITitle = (props: any) => {
  const {
    className,
    style,
    icon,
    titleEn,
    titleCn,
    children,
    ...restProps
  } = props || {};

  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  return (
    <div
      className={classNames('dbh-studio-BI-title-container', className)}
      style={style}
    >
      <div className='dbh-studio-BI-title'>
        <img src={icon} />
        <div>{getName(isEn, titleEn, titleCn)}</div>
      </div>
      {React.Children.map(children, (child: any) => {
        return React.cloneElement(
          child,
          { ...restProps }
        );
      })}
    </div>
  );
};

export default BITitle;
